import * as React from 'react';
import type { SVGProps } from 'react';
const SvgThreats = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="currentColor"
    {...props}
  >
    <path d="M3.619 7.575v3.674c0 5.027 6.804 8.556 7.456 8.556s7.306-3.53 7.306-8.556V6.426c0-.218-.044-.43-.128-.622l-5.174 5.678a.105.105 0 0 1-.179-.042l-.58-2.046a.105.105 0 0 0-.19-.024l-3.204 5.492 3.021-9.136a.105.105 0 0 1 .188-.024l1.394 2.13a.105.105 0 0 0 .175.001l2.328-3.449-4.415-1.878a1.58 1.58 0 0 0-1.234 0l-5.806 2.47a1.58 1.58 0 0 0-.958 1.45v1.15Z" />
  </svg>
);
export default SvgThreats;
